import { AuthPollerTask } from "./auth_poller";
import { AuthTokenPollerTask } from "./auth_token_poller";
import { AvCheckInTask } from "./av_check_in_task";
import { PresenceTask } from "./presence_task";
import { PubsubStatsTask } from "./pubsub_stats_task";

import { NullErrorBoundary, OverlayErrorBoundary } from "components/error_boundary";

function Tasks() {
  return (
    <>
      <OverlayErrorBoundary>
        <AuthPollerTask />
      </OverlayErrorBoundary>
      <OverlayErrorBoundary>
        <AuthTokenPollerTask />
      </OverlayErrorBoundary>
      <NullErrorBoundary>
        <AvCheckInTask />
      </NullErrorBoundary>
      <NullErrorBoundary>
        <PubsubStatsTask />
      </NullErrorBoundary>
      <OverlayErrorBoundary>
        <PresenceTask />
      </OverlayErrorBoundary>
    </>
  );
}

export { Tasks };
